import React from 'react';
import {connect} from 'react-redux';
import {getCellBgColor} from 'helpers/common-helper';
import PlayersInfo from 'desktop/elements/players/info';
import {RankPlayersList as BasePlayersList} from 'components/organisms/players-list/ranks';
import RankPlayerExclusionState from 'components/molecules/player-exclusion/rank-player-exclusion-state';
import RankPlayersGroupExclusionSwitcher from 'components/molecules/player-exclusion/rank-players-group-exclusion-switcher';
import Tooltip from 'components/atoms/tooltip';
import Loader from 'components/atoms/loaders/loader';

class PlayersList extends BasePlayersList {
    componentDidUpdate(prevProps) {
        const {
            userPointsType,
            reset: {settings: resetSettings},
        } = this.props;
        const {userPointsType: prevUPType} = prevProps;

        if (this.wasSettingsReset(resetSettings)) {
            this.updateResetSettingsSignature(resetSettings);
            super.resetBaseState({
                sortBy: {
                    col: 'gameInfo',
                    direction: 'desc',
                },
            });
        } else if (!userPointsType.isUserPointsTypeEqual(prevUPType.getUserPointsType())) {
            super.resetBaseState({
                sortBy: {...this.state.sortBy},
            });
        }
    }

    componentDidMount() {
        this.sortBy(new Event('click'), 'gameInfo');
    }

    getSearchConditions() {
        return {
            ...this.getSearchRuleByMode(),
            ...this.getSearchRuleByPlayerName(),
        };
    }

    render() {
        const {players, sportConfig, playersFilter} = this.props;

        if (!players.isPlayersGroupReady()) {
            return <Loader />;
        }

        const activeMode = playersFilter.playersType;
        const playersList = this.getPlayersForRendering();
        const renderKey = this.getRenderKey();

        const rows = [];
        if (playersList.length > 0) {
            let shadingOptions = sportConfig.getShadingOptions();
            playersList.map((player, index) => {
                const userScore = player.getPropValueOfMode('userScore');
                const userScoreBgColor = getCellBgColor(userScore, shadingOptions.userScore);
                const pointsBgColor = getCellBgColor(player.points, shadingOptions.points);

                rows.push(
                    <tr key={index}>
                        <td className="td-chk">
                            <RankPlayerExclusionState
                                activeMode={activeMode}
                                playerMode={player.getMode()}
                                playerId={player.getId()}
                            />
                        </td>
                        <td className="td-lock">
                            {this.getPlayerLockView({
                                playerId: player.getId(),
                                playerMode: player.getMode(),
                                activeMode,
                            })}
                        </td>
                        <td>
                            <span>{player.name}</span>
                        </td>
                        <td>{this.getPlayerSympathyComponent({player, activeMode})}</td>
                        <td>{this.getPlayerRankView({activeMode, playerMode: player.getMode()})}</td>
                        <td className="text-capitalize">
                            <span>{player.opponent}</span>
                        </td>
                        <td>
                            <span>{player.getPropValueOfMode('salary')}</span>
                        </td>
                        <td className="color-cell" style={{...userScoreBgColor}}>
                            <span>{userScore}</span>
                        </td>
                        <td className="color-cell" style={{...pointsBgColor}}>
                            <span>{player.getPropValueOfMode('points')}</span>
                        </td>
                        <td>
                            <span>{player.getPropValueOfMode('fptsWin')}</span>
                        </td>
                        <td>
                            <span>{player.getPropValueOfMode('adminPoints')}</span>
                        </td>
                        {this.getFinalPointsBlock({
                            points: player.getPropValueOfMode('fantasyPoints'),
                        })}
                        <td className="td-narrow">
                            {this.wrapContentInTooltip(
                                this.getPlayerPointsComponent({
                                    player,
                                    activeMode,
                                }),
                                `Default Score: ${player.getPropValueOfMode('adminPoints')}`,
                            )}
                        </td>
                        <td>
                            <span>{player.projOwn.getValue()}</span>
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerExposureComponent({
                                playerId: player.getId(),
                                propName: 'exposureMin',
                                mode: player.getMode(),
                            })}
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerMaxExposureComponent({
                                player,
                                activeMode,
                            })}
                        </td>
                    </tr>,
                );
            });
        } else {
            rows.push(
                <tr key="players-not-found">
                    <td colSpan="13" className="text-center">
                        Players were not found.
                    </td>
                </tr>,
            );
        }

        return (
            <div>
                <div className="main-table table-holder table-scroll">
                    <table className="table players-pool">
                        <thead>
                            <tr>
                                <th className="td-chk">
                                    <RankPlayersGroupExclusionSwitcher players={playersList} activeMode={activeMode} />
                                </th>
                                <th colSpan="3">
                                    <a
                                        className={super.getSortDirectionClassName('name')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'name')}
                                    >
                                        Name
                                    </a>
                                </th>
                                <th></th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('opponent')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'opponent')}
                                    >
                                        Opponent
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('salary')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'salary')}
                                    >
                                        Salary
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userScore')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userScore')}
                                    >
                                        Fpts/$
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('points')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'points')}
                                    >
                                        Odds
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('fptsWin')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'fptsWin')}
                                    >
                                        Fpts/Win
                                    </a>
                                    &nbsp;
                                    <Tooltip subject={'Fantasy Points Projection in a Win'} />
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('adminPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'adminPoints')}
                                    >
                                        Proj
                                    </a>
                                </th>
                                {this.getFinalPointsHeaderSort()}
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userPoints')}
                                    >
                                        FPts
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('projected_ownership')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'projected_ownership')}
                                    >
                                        pOwn%
                                    </a>
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMin')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMin')}
                                    >
                                        Exp. min
                                    </a>
                                    {this.getGeneralExposureComponent({
                                        players: playersList,
                                        propName: 'exposureMin',
                                        mode: activeMode,
                                    })}
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMax')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMax')}
                                    >
                                        Exp. max
                                    </a>
                                    {this.getGeneralMaxExposureComponent({
                                        players: playersList,
                                        activeMode,
                                    })}
                                </th>
                            </tr>
                        </thead>

                        <tbody>{rows}</tbody>
                    </table>
                </div>

                <PlayersInfo playersQuantity={playersList.length} />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        reset,
        playersLock,
        userPointsType,
        modesConfig,
        playersData: {
            players,
            filters,
        },
    } = state;

    return {
        players,
        playersFilter: filters,
        playersLock,
        sportConfig,
        reset,
        userPointsType,
        modesConfig,
    };
}

const Table = connect(mapStatesToProps)(PlayersList);

export {Table};
